module.exports = __webpack_public_path__ + "img/scene_relax_big@2x.e2980d0f.png";